import axios from 'axios';
import { createAsyncThunk, isFulfilled, isPending, isRejected } from '@reduxjs/toolkit';

import { createEntitySlice, EntityState } from 'app/shared/reducers/reducer.utils';
import { defaultValue, IKpiPresetWeightVehicle } from 'app/shared/model/kpi-preset-weight-vehicle.model';

const initialState: EntityState<IKpiPresetWeightVehicle> = {
  loading: false,
  errorMessage: null,
  entities: [],
  entity: defaultValue,
  updating: false,
  totalItems: 0,
  updateSuccess: false,
};

const apiUrl = 'api/kpi-preset-weight-vehicles';

// Actions

export const getEntitiesByPreset = createAsyncThunk(
  'kpiPresetWeightVehicle/fetch_entity_list_by_preset',
  async (params: { presetId?: number | null; companyId?: number | null }) => {
    const { presetId, companyId } = params;
    const presetParam = presetId !== undefined && presetId !== null ? presetId : 'null';

    let requestUrl = `${apiUrl}/preset/${presetParam}`;

    if (companyId !== null && companyId !== undefined) {
      requestUrl += `?companyId=${companyId}`;
    }

    return axios.get<IKpiPresetWeightVehicle[]>(requestUrl);
  }
);

// slice

export const KpiPresetWeightVehicleSlice = createEntitySlice({
  name: 'kpiPresetWeightVehicle',
  initialState,
  extraReducers(builder) {
    builder
      .addMatcher(isFulfilled(getEntitiesByPreset), (state, action) => {
        return {
          ...state,
          loading: false,
          entities: action.payload.data,
        };
      })
      .addMatcher(isPending(getEntitiesByPreset), state => {
        state.errorMessage = null;
        state.updateSuccess = false;
        state.loading = true;
      });
  },
});

export const { reset } = KpiPresetWeightVehicleSlice.actions;

// Reducer
export default KpiPresetWeightVehicleSlice.reducer;
